<template>
  <div>
    <h3 class="account-sub-title d-none d-md-block mt-0 pt-1 ml-1">
      <i class="icon-user-2 align-middle mr-3 pr-1"></i>
      {{ translations.newDocument }}
    </h3>
    <div class="account-content">
      <form @submit.prevent="handleSubmit">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label for="first-name">
                {{ translations.tables.name }}
                <span class="required">*</span>
              </label>
              <input
                v-model="title"
                type="text"
                class="form-control"
                :placeholder="translations.tables.name"
                id="title"
                required
              />
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group">
              <label for="last-name">
                {{ translations.document }}
                <span class="required">*</span>
              </label>
              <div class="form-group row align-items-center mb-3">
                <div class="col-lg-7 col-xl-6">
                  <input
                    type="file"
                    accept="image/*"
                    class="form-control form-control-custom"
                    ref="document"
                    @change="handleDocumentUpload"
                  >
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="form-footer mt-3 mb-0">
          <button type="submit" class="btn btn-primary mr-0">{{ translations.save }}</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import api from '@/services/api';
import { translations } from '@/mixins';

export default {
  name: 'NewAddress',
  mixins: [translations],
  data() {
    return {
      title: '',
    };
  },
  computed: {
    countries() {
      return this.$store.getters.getCountries;
    },
    towns() {
      return this.$store.getters.getTowns;
    },
  },
  mounted() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  },
  methods: {
    handleSubmit() {
      const file = this.$refs.document.files[0];
      const { title } = this;

      const formData = new FormData();

      formData.append('title', title);
      formData.append('file', file);

      api
        .createUserFile(formData)
        .then((response) => {
          this.$toast.info(response.data.info);
          this.$router.push({ name: 'MyFiles' });
        });
    },
    handleDocumentUpload() {
      const file = this.$refs.document.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = (e) => {
        this.document = e.target.result;
      };
    },
  },
};
</script>

<style lang="scss" scoped>
input, button, select, optgroup, textarea {
    margin: 0;
    font-family: inherit;
    font-size: inherit;
    line-height: inherit;
}

.form-control-custom {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  font-size: 14px;
}

.form-control-custom[type=file] {
  overflow: hidden;
}

.form-control-custom[type=file]:not(:disabled):not([readonly]) {
  cursor: pointer;
}

.form-control-custom:focus {
  color: #212529;
  background-color: #fff;
  border-color: #86b7fe;
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  height: 30px;
}

.form-control-custom::file-selector-button {
  color: #212529;
  background-color: #e9ecef;
  pointer-events: none;
  border-color: inherit;
  border-style: solid;
  border-width: 0;
  border-inline-end-width: 1px;
  border-radius: 0;
  height: 45px;
  font-size: 12px;
}

.form-control-custom::-webkit-file-upload-button {
  padding: 0.375rem 0.75rem;
  margin: -0.375rem -0.75rem;
  -webkit-margin-end: 0.75rem;
  margin-inline-end: 0.75rem;
}

.form-control-custom:hover:not(:disabled):not([readonly])::-webkit-file-upload-button {
  background-color: #dde0e3;
}
</style>
